import React from 'react'
import { useAppSelector } from '@/shared/lib/redux'
import { selectCommunityInfo, selectCommunityLoading } from '@/entities/community'
import { HeaderDropdown } from './header-dropdown'
import { Loader } from '@/shared/ui/loader'

interface PageHeaderProps {
    title: string
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title }) => {
    const community = useAppSelector(selectCommunityInfo)
    const communityInfoLoading = useAppSelector(selectCommunityLoading)

    return (
        <div className='flex justify-between items-center w-full mb-7'>
            <div className='text-[42px] font-mediumttf uppercase'>
                { title }
            </div>
            <div className='flex gap-3 items-end'>
                <div className='flex flex-col'>
                    <div className='font-bold text-color-dark text-right text-[15px'>
                        {communityInfoLoading
                            ? <div className='flex w-full justify-end pr-4 mb-1'>
                                <Loader />
                            </div> 
                            : community.community_name
                        }
                        
                    </div>
                    <div className='text-[#777777] text-[13px] text-right font-medium'>
                        Администратор
                    </div>
                </div>
                <HeaderDropdown />
            </div>
        </div>
    )
}